












import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ComponentFinxLayout extends Vue {
  @Prop({ required: false, default: 'Título da página' }) source: string
}
